module.exports = __webpack_public_path__ + "static/media/retirement-object-1-0-3.53d36ee1.svg";